import useUpdateEffect from './useUpdateEffect';

function useOnUpdate(fn, inputs) {
  useUpdateEffect(didUpdate => {
    if (didUpdate) fn();
  }, inputs);
}

export default useOnUpdate;
